module.exports = __webpack_public_path__ + "images/jobs/dollar.e1c1eee7.svg";